import { post, get, del } from '@/api/http'
import { configNginxUrl, declareNginxUrl } from '@/api/baseUrl'

//获取用户信息
const getUserInfo = (params, config) => {
  return post(`${declareNginxUrl}/sso/getUserInfo`, params, config);
}

//纳税主体名称
const taxPayerName = (params, config) => {
  return post(`${configNginxUrl}/taxtaxpayeridentifyinfo/getTaxpayerInfoList`, params, config);
}

export default {
  getUserInfo,
  taxPayerName
}


//调用示例：this.commonApi.getUserInfo().then(resp => {})



// WEBPACK FOOTER //
// ./src/api/common.js